/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Link_ExpiresInputs */



/**
* | output |
* | --- |
* | "The link expires in 15 minutes." |
*
* @param {Login_Link_ExpiresInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const login_link_expires = /** @type {((inputs?: Login_Link_ExpiresInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Link_ExpiresInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Le lien expire dans 15 minutes.")
	if (locale === "es") return /** @type {LocalizedString} */ ("El enlace expira en 15 minutos.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("O link expira em 15 minutos.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Il link scade tra 15 minuti.")
	return /** @type {LocalizedString} */ ("The link expires in 15 minutes.")
});